console.info(
    `   ___               _     ___    ___  \r\n  / _ \\  ___   _ __ | |_  ( _ )  / _ \\ \r\n / /_)/ / _ \\ | '__|| __| / _ \\ | | | |\r\n/ ___/ | (_) || |   | |_ | (_) || |_| |\r\n\\/      \\___/ |_|    \\__| \\___/  \\___/ \r\n                                       \r\n https://www.port80webdesign.com`
);

if (typeof p80 === 'undefined') {
    var p80 = {};
}

/***
 *
 *  Media Query Listener
 *
 *  Used for targetting specific breakpoints for devices via JS.
 *  Because Shopify has updated the viewport tag in the latest Dawn `window.innerWidth` etc are no longer reliable on mobile devices for exact pixel comparisons
 *  Instead we need to match media breakpoints to determine what size device is viewing
 *
 *  You can see just below the class definition for `MediaQueryListener` that I have instanced this globally as `p80.mediaQueryService`
 *  `p80.mediaQueryService = new MediaQueryListener();`
 *  Should you ever need to directly access the current breakpoint you can do so via `p80.mediaQueryService.currentMediaQuery`
 *  However the intent is that you will use this in combination with the new event listener system that has been integrated
 *  Accessing the instance directly is only to cover edge cases and initalization
 *
 *  You can view an example of how this works via `ProductSlider`
 *
 */

class MediaQueryListener {
    constructor() {
        this.mediaTypes = {
            small: 'small',
            medium: 'medium',
            large: 'large',
            touch: 'touch'
        };
        this.mediaQueries = [
            { query: window.matchMedia('(max-width: 749px)'), type: 'small' },
            {
                query: window.matchMedia('(min-width: 750px) and (max-width: 989px'),
                type: 'medium'
            },
            { query: window.matchMedia('(min-width: 990px)'), type: 'large' },
            { query: window.matchMedia('(pointer: coarse)'), type: 'touch' }
        ];

        this.touchSupport = window.matchMedia('(pointer: coarse)').matches;

        this.queryChangeHandler = this.onQueryChange.bind(this);

        this.currentMediaQuery = this.mediaQueries.find((queryOption) => {
            return queryOption.query.matches && queryOption.query.type !== this.mediaTypes.touch;
        });

        this.mediaQueries.forEach((queryOption) => {
            queryOption.query.addEventListener(
                'change',
                this.queryChangeHandler.bind(this, queryOption)
            );
        });

        document.addEventListener('DOMContentLoaded', this.publish());
    }

    onQueryChange(queryOption) {
        if (
            queryOption &&
            queryOption.query &&
            queryOption.query.matches &&
            this.currentMediaQuery.type === queryOption.type
        ) {
            return;
        }

        if (queryOption.type !== this.mediaTypes.touch) {
            const previousMedia = this.currentMediaQuery;
            const newMedia = this.mediaQueries.find((queryOption) => {
                return queryOption.query.matches;
            });
            if (previousMedia && previousMedia.type === newMedia.type) return;
            this.currentMediaQuery = newMedia;
        } else {
            this.touchSupport = queryOption.query.matches;
        }

        this.publish();
    }

    publish() {
        if (typeof publish === 'undefined') return;
        publish(PUB_SUB_EVENTS.mediaQueryChange, {
            source: 'MediaQueryListener',
            currentMedia: this.currentMediaQuery,
            touchSupport: this.touchSupport
        });
    }
}

p80.mediaQueryService = new MediaQueryListener();

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, input, ajax-cart-toggle, cart-notification-modal-close"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
            'aria-expanded',
            !event.currentTarget.closest('details').hasAttribute('open')
        );
    });

    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN'
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        'focus',
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
            '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
            '*'
        );
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this)
        );
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                // eslint-disable-next-line no-redeclare
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = '';
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll(
            'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
        ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen
                ? this.closeMenuDrawer(event, summaryElement)
                : this.openMenuDrawer(summaryElement);

            if (window.matchMedia('(max-width: 990px)')) {
                document.documentElement.style.setProperty(
                    '--viewport-height',
                    `${window.innerHeight}px`
                );
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener(
                          'transitionend',
                          addTrapFocus
                      );
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);

        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    }

    onFocusOut() {
        setTimeout(() => {
            if (
                this.mainDetailsToggle.hasAttribute('open') &&
                !this.mainDetailsToggle.contains(document.activeElement)
            )
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(
                        detailsElement.closest('details[open]'),
                        detailsElement.querySelector('summary')
                    );
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        this.borderOffset =
            this.borderOffset ||
            this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
                ? 1
                : 0;
        document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
        );
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        window.addEventListener('resize', this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        this.header &&
            document.documentElement.style.setProperty(
                '--header-bottom-position',
                `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
            );
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (
                    event.pointerType === 'mouse' &&
                    !event.target.closest('deferred-media, product-model')
                )
                    this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.bind();
    }

    bind() {
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(
                this.querySelector('template').content.firstElementChild.cloneNode(true)
            );

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(
                content.querySelector('video, model-viewer, iframe')
            );
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
            (element) => element.clientWidth > 0
        );
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        // Temporarily prevents unneeded updates resulting from variant changes
        // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
        if (!this.slider || !this.nextButton) return;

        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
            element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
            element.offsetLeft >= this.slider.scrollLeft
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === 'next'
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
        this.slider.scrollTo({
            left: position
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide glide__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
        // Value below should match --duration-announcement-bar CSS value
        this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

        this.sliderControlLinksArray = Array.from(
            this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
        );
        this.sliderControlLinksArray.forEach((link) =>
            link.addEventListener('click', this.linkToSlide.bind(this))
        );
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.announcementBarSlider) {
            this.announcementBarArrowButtonWasClicked = false;

            this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.reducedMotion.addEventListener('change', () => {
                if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
            });

            [this.prevButton, this.nextButton].forEach((button) => {
                button.addEventListener(
                    'click',
                    () => {
                        this.announcementBarArrowButtonWasClicked = true;
                    },
                    { once: true }
                );
            });
        }

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        if (this.querySelector('.slideshow__autoplay')) {
            this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
            this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
            this.autoplayButtonIsSetToPlay = true;
            this.play();
        } else {
            this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
                ? this.pause()
                : this.play();
        }
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        this.wasClicked = true;

        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) {
            this.applyAnimationToAnnouncementBar(event.currentTarget.name);
            return;
        }

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition =
                this.slider.scrollLeft +
                this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }

        this.setSlidePosition(this.slideScrollPosition);

        this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    }

    setSlidePosition(position) {
        if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
        this.setPositionTimeout = setTimeout(() => {
            this.slider.scrollTo({
                left: position
            });
        }, this.announcerBarAnimationDelay);
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add(
            'slider-counter__link--active'
        );
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton ||
                this.sliderAutoplayButton.contains(event.target);
            if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
            this.play();
        } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
            this.play();
        }
    }

    focusInHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton ||
                this.sliderAutoplayButton.contains(event.target);
            if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
                this.play();
            } else if (this.autoplayButtonIsSetToPlay) {
                this.pause();
            }
        } else if (this.announcementBarSlider.contains(event.target)) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute(
                'aria-label',
                window.accessibilityStrings.playSlideshow
            );
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute(
                'aria-label',
                window.accessibilityStrings.pauseSlideshow
            );
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length
                ? 0
                : this.slider.scrollLeft + this.sliderItemOffset;

        this.setSlidePosition(slideScrollPosition);
        this.applyAnimationToAnnouncementBar();
    }

    setSlideVisibility(event) {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll('a');
            if (index === this.currentPage - 1) {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.removeAttribute('tabindex');
                    });
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.setAttribute('tabindex', '-1');
                    });
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
        this.wasClicked = false;
    }

    applyAnimationToAnnouncementBar(button = 'next') {
        if (!this.announcementBarSlider) return;

        const itemsCount = this.sliderItems.length;
        const increment = button === 'next' ? 1 : -1;

        const currentIndex = this.currentPage - 1;
        let nextIndex = (currentIndex + increment) % itemsCount;
        nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

        const nextSlide = this.sliderItems[nextIndex];
        const currentSlide = this.sliderItems[currentIndex];

        const animationClassIn = 'announcement-bar-slider--fade-in';
        const animationClassOut = 'announcement-bar-slider--fade-out';

        const isFirstSlide = currentIndex === 0;
        const isLastSlide = currentIndex === itemsCount - 1;

        const shouldMoveNext =
            (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
        const direction = shouldMoveNext ? 'next' : 'previous';

        currentSlide.classList.add(`${animationClassOut}-${direction}`);
        nextSlide.classList.add(`${animationClassIn}-${direction}`);

        setTimeout(() => {
            currentSlide.classList.remove(`${animationClassOut}-${direction}`);
            nextSlide.classList.remove(`${animationClassIn}-${direction}`);
        }, this.announcerBarAnimationDelay * 2);
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
                (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.assemblyDataEl = this.querySelector('#assembly-json');
        this.preorderDataEl = this.querySelector('#preorder-json');
        this.shippableDataEl = this.querySelector('#shippable-json');
        if (this.assemblyDataEl) {
            this.getAssemblyData();
            this.updateVariantAssembly();
        }
        if (this.preorderDataEl) {
            this.getPreorderData();
            this.updateVariantPreorder();
        }
        if (this.shippableDataEl) {
            this.getShippableData();
            this.updateShippableState();
        }
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateCurrentColor();
        this.updateCurrentSkuVariant();
        this.updateVariantAssembly();
        this.updateVariantPreorder();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }

        this.updateStorePickup();
        this.updateShippableState();
    }

    updateCurrentColor() {
        const currentColorEl = this.querySelector('.current-color');
        if (!currentColorEl) return;
        const optionNumber = currentColorEl.dataset.optionNumber;
        const currentVariant = this.currentVariant;
        if (currentVariant[optionNumber] == null) return;
        currentColorEl.textContent = currentVariant[optionNumber];
    }

    updateCurrentSkuVariant() {
        const productInfo = this.closest('product-info');
        const currentVariant = this.currentVariant;
        if (!productInfo) return;
        const skuVariantEl = productInfo.querySelector('[data-sku-variant]');
        if (!skuVariantEl) return;
        let skuVariantText = '';
        if (currentVariant.sku != '' && currentVariant.public_title != '') {
            skuVariantText = `${currentVariant.sku} - ${currentVariant.public_title}`;
        } else if (currentVariant.sku != '') {
            skuVariantText = currentVariant.sku;
        } else if (currentVariant.public_title != '') {
            skuVariantText = currentVariant.public_title;
        }
        skuVariantEl.textContent = `SKU: ${skuVariantText}`;
    }

    updateStorePickup() {
        if (!this.currentVariant) return;
        window.updatePickupAvailability(this.currentVariant.id);
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
            if (element.tagName === 'SELECT') {
                return element.value;
            }
            if (element.tagName === 'FIELDSET') {
                return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)
                    ?.value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateSelectedSwatchValue({ target }) {
        const { name, value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = this.querySelector(
                `[data-selected-dropdown-swatch="${name}"] > .swatch`
            );
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = this.querySelector(
                `[data-selected-swatch-value="${name}"]`
            );
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
            {},
            '',
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
            `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter(
                    (variant) =>
                        variant.available && variant[`option${index}`] === previousOptionSelected
                )
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === 'INPUT') {
                element.classList.toggle('disabled', !availableElement);
            } else if (element.tagName === 'OPTION') {
                element.innerText = availableElement
                    ? value
                    : window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    updateMedia(html) {
        const mediaGallerySource = document.querySelector(
            `[id^="MediaGallery-${this.dataset.section}"] ul`
        );
        const mediaGalleryDestination = html.querySelector(
            `[id^="MediaGallery-${this.dataset.section}"] ul`
        );

        const refreshSourceData = () => {
            const mediaGallerySourceItems = Array.from(
                mediaGallerySource.querySelectorAll('li[data-media-id]')
            );
            const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
            const sourceMap = new Map(
                mediaGallerySourceItems.map((item, index) => [
                    item.dataset.mediaId,
                    { item, index }
                ])
            );
            return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
            let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            const mediaGalleryDestinationItems = Array.from(
                mediaGalleryDestination.querySelectorAll('li[data-media-id]')
            );
            const destinationSet = new Set(
                mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
            );
            let shouldRefresh = false;

            // add items from new data not present in DOM
            for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
                if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
                    mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                    shouldRefresh = true;
                }
            }

            // remove items from DOM not present in new data
            for (let i = 0; i < mediaGallerySourceItems.length; i++) {
                if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
                    mediaGallerySourceItems[i].remove();
                    shouldRefresh = true;
                }
            }

            // refresh
            if (shouldRefresh)
                [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

            // if media galleries don't match, sort to match new data order
            mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
                const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

                if (sourceData && sourceData.index !== destinationIndex) {
                    mediaGallerySource.insertBefore(
                        sourceData.item,
                        mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
                    );

                    // refresh source now that it has been modified
                    [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
                }
            });
        }

        const mediaGalleryEl = document.querySelector(
            `[id^="MediaGallery-${this.dataset.section}"]`
        );
        if (mediaGalleryEl) {
            mediaGalleryEl.setActiveMedia(
                `${this.dataset.section}-${this.currentVariant.featured_media?.id}`
            );
        }

        // update media modal
        const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        const newModalContent = html.querySelector(`product-modal`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;

        fetch(
            `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
                this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );
                const skuSource = html.getElementById(
                    `Sku-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(
                    `Inventory-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );
                const inventoryDestination = document.getElementById(
                    `Inventory-${this.dataset.section}`
                );

                const volumePricingSource = html.getElementById(
                    `Volume-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );

                this.updateMedia(html);

                const pricePerItemDestination = document.getElementById(
                    `Price-Per-Item-${this.dataset.section}`
                );
                const pricePerItemSource = html.getElementById(
                    `Price-Per-Item-${
                        this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section
                    }`
                );

                const volumePricingDestination = document.getElementById(
                    `Volume-${this.dataset.section}`
                );
                const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

                if (volumeNote) volumeNote.classList.remove('hidden');
                if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
                if (qtyRules) qtyRules.classList.remove('hidden');

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination)
                    inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle(
                        'hidden',
                        skuSource.classList.contains('hidden')
                    );
                }

                if (volumePricingSource && volumePricingDestination) {
                    volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                }

                if (pricePerItemSource && pricePerItemDestination) {
                    pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                    pricePerItemDestination.classList.toggle(
                        'hidden',
                        pricePerItemSource.classList.contains('hidden')
                    );
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination)
                    inventoryDestination.classList.toggle(
                        'hidden',
                        inventorySource.innerText === ''
                    );

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant
                    }
                });

                this.updateVariantAssembly();
                this.updateVariantPreorder();
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    getAssemblyData() {
        const assemblyDataEl = this.assemblyDataEl;
        if (!assemblyDataEl) return;
        this.assemblyData = this.assemblyData || JSON.parse(assemblyDataEl.textContent);
        if (!this.assemblyData) return;
        return this.assemblyData;
    }

    updateVariantAssembly() {
        try {
            if (!this.assemblyData) return;
            const assemblyInputEl = this.querySelector('[data-assembly-fee]');
            if (!assemblyInputEl) return;
            assemblyInputEl.value = '';

            const productInfo = this.closest('product-info');
            const assemblyFeeNoticeEl = productInfo.querySelector('.assembly-fee--notice');
            const currentVariantId =
                this.currentVariant?.id || productInfo.querySelector('[name="id"]')?.value;

            if (assemblyFeeNoticeEl) assemblyFeeNoticeEl.innerHTML = '';

            if (!currentVariantId) return;

            const assemblyItem = this.assemblyData.find(
                (item) => item.variant_id == currentVariantId
            );

            if (!assemblyItem) return;

            if (assemblyItem && assemblyItem.assembly_message) {
                assemblyInputEl.value = assemblyItem.assembly_message;
            }
            if (assemblyFeeNoticeEl) {
                assemblyFeeNoticeEl.innerHTML = `<span class="alert-message alert-message--attention">${assemblyItem.assembly_message}</span>`;
            }
        } catch (error) {
            console.error('Error updating variant assembly:', error);
        }
    }

    getPreorderData() {
        const preorderDataEl = this.preorderDataEl;
        if (!preorderDataEl) return;
        this.preorderButtonText = preorderDataEl.dataset.preorder;
        this.preorderData = this.preorderData || JSON.parse(preorderDataEl.textContent);
        if (!this.preorderData) return;
        return this.preorderData;
    }

    updateVariantPreorder() {
        try {
            if (!this.preorderData) return;
            const shipDateInputEl = this.querySelector('[data-ship-date]');
            if (!shipDateInputEl) return;
            shipDateInputEl.value = '';

            const productInfo = this.closest('product-info');
            const inputId = productInfo.querySelector(`[name="id"]`);
            const currentVariantId = this.currentVariant?.id || inputId?.value;

            if (!currentVariantId) return;
            const preorderItem = this.preorderData.find(
                (item) => item.variant_id == currentVariantId
            );
            if (!preorderItem) return;

            const addButtonText = productInfo.querySelector('[name="add"] > span');

            const availableDate = preorderItem.available_date;
            const buttonText = this.preorderButtonText.replace('#date#', availableDate);
            addButtonText.textContent = buttonText;
            shipDateInputEl.value = availableDate;
        } catch (error) {
            console.error('Error updating preorder variant:', error);
        }
    }

    getShippableData() {
        const shippableDataEl = this.shippableDataEl;
        if (!shippableDataEl) return;
        this.shippableData = this.shippableData || JSON.parse(shippableDataEl.textContent);
        if (!this.shippableData) return;
        return this.shippableData;
    }

    updateShippableState() {
        try {
            if (!this.shippableData) return;
            const productInfo = this.closest('product-info');
            const inputId = productInfo.querySelector(`[name="id"]`);
            const shippableQtyBoolEl = productInfo.querySelector(`#shippable_quantity_boolean`);
            const currentVariantId = this.currentVariant?.id || inputId?.value;

            const shippableStateEl = productInfo.querySelector('.delivery-avail__status');
            if (!shippableStateEl) return;
            shippableStateEl.setAttribute('data-shippable', 'false');

            if (!currentVariantId) return;
            const shippableItem = this.shippableData.find(
                (item) => item.variant_id == currentVariantId
            );
            if (!shippableItem) return;

            const shippableState = shippableItem.shippable;
            shippableStateEl.setAttribute('data-shippable', shippableState);
            shippableQtyBoolEl.value = shippableState == true ? 'True' : 'False';
        } catch (error) {
            console.error('Error updating preorder variant:', error);
        }
    }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                    if (
                        !this.querySelector('slideshow-component') &&
                        this.classList.contains('complementary-products')
                    ) {
                        this.remove();
                    }

                    if (html.querySelector('.grid__item')) {
                        this.classList.add('product-recommendations--loaded');
                    }
                    publish(PUB_SUB_EVENTS.glideUpdate, { id: this.id });

                    // re-initiaze the compare-bar
                    const compareBar = document.querySelector('compare-bar');
                    if (!compareBar) return;
                    compareBar.initialize();
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 400px 0px'
        }).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);

/***
 *
 * Free Shipping Threshold Bar
 *
 * @param {number} (required) data-threshold - the value (in cents) required to hit the free shipping threshold
 * @param {number} (optional) data-total - the total value of items in the cart on initialization (if available)
 *
 */

class FreeShippingBar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // The current shop currency
        this.currency = Shopify && Shopify.currency ? Shopify.currency.active : null;
        if (!this.currency) {
            console.error('Currency code not specified.');
            return;
        }
        // Free shipping threshold has not been met messaging
        this.freeShippingPending = this.querySelector('[data-free-shipping-pending]');
        // The current cart total within the pending messaging
        this.freeShippingPendingTotal = this.freeShippingPending
            ? this.freeShippingPending.querySelector('[data-amount]')
            : null;
        // Free shipping threshold has been met messaging
        this.freeShippingMet = this.querySelector('[data-free-shipping-met]');
        // The progress bar
        this.progress = this.querySelector('progress');
        // The free shipping threshold
        this.threshold = this.getAttribute('data-threshold');
        if (this.threshold) this.threshold = parseInt(this.threshold, 10);
        // The total price of the cart
        this.cartTotal = this.getAttribute('data-total');
        if (this.cartTotal) this.cartTotal = parseInt(this.cartTotal, 10);

        this.updateShipping();

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (!event.cartData || typeof event.cartData.total_price === 'undefined') return;
            this.cartTotal = event.cartData.total_price;
            this.updateShipping();
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    updateShipping() {
        if (typeof this.threshold === 'undefined' || this.threshold === null) return;

        const getLang = () => {
            if (navigator.languages != undefined) return navigator.languages[0];
            return navigator.language;
        };

        if (typeof this.cartTotal === 'undefined' || this.cartTotal === null) {
            let defaultPrice = this.threshold;
            defaultPrice = defaultPrice / 100;
            defaultPrice = defaultPrice.toLocaleString(getLang(), {
                style: 'currency',
                currency: this.currency
            });
            if (this.freeShippingPendingTotal)
                this.freeShippingPendingTotal.textContent = defaultPrice;
            if (this.progress) this.progress.setAttribute('value', 0);
            return;
        }
        if (this.cartTotal >= this.threshold) {
            if (this.freeShippingPending) this.freeShippingPending.classList.add('hidden');
            if (this.freeShippingMet) this.freeShippingMet.classList.remove('hidden');
        } else {
            if (this.freeShippingPending) this.freeShippingPending.classList.remove('hidden');
            if (this.freeShippingMet) this.freeShippingMet.classList.add('hidden');
        }
        if (this.progress) this.progress.setAttribute('value', this.cartTotal);
        if (this.freeShippingPendingTotal)
            this.freeShippingPendingTotal.textContent = this.formatThreshold();
    }

    formatThreshold() {
        if (typeof this.cartTotal === 'undefined' || this.cartTotal === null || !this.currency)
            return;

        const getLang = () => {
            if (navigator.languages != undefined) return navigator.languages[0];
            return navigator.language;
        };

        let price = this.threshold - this.cartTotal;
        if (price < 0) price = 0;
        price = price / 100;
        price = price.toLocaleString(getLang(), {
            style: 'currency',
            currency: this.currency
        });
        return price;
    }
}

customElements.define('free-shipping-bar', FreeShippingBar);

class AccordionItem {
    constructor(element, config) {
        this.mobileOnly = (config && config.mobileOnly) || false;
        this.details = element;
        this.summary = this.details.querySelector('summary');
        this.content = this.details.querySelector('.p80-accordion__content');
        this.open = this.details.open ? true : false;
        this.onTransitionEndHandler = this.onTransitionEnd.bind(this);
        this.onClickHandler = this.onClick.bind(this);
        this.onKeyDownHandler = this.onKeyDown.bind(this);
        this.summary.addEventListener('click', this.onClickHandler);
        this.summary.addEventListener('keydown', this.onKeyDownHandler);
        this.toggleFocusable();
    }

    onClick(event) {
        event?.preventDefault();
        if (
            this.mobileOnly &&
            this.currentMediaQuery.type !== p80.mediaQueryService.mediaTypes.small
        )
            return;
        this.details.open ? this.yieldAndClose() : this.yieldAndOpen();
    }

    onKeyDown(event) {
        if (event?.code.toUpperCase() === 'SPACE' || event?.code.toUpperCase() === 'ENTER') {
            event?.preventDefault();
            if (
                this.mobileOnly &&
                this.currentMediaQuery !== p80.mediaQueryService.mediaTypes.small
            )
                return;
            this.open();
        }
    }

    onTransitionEnd(event) {
        if (event?.propertyName !== 'height' || event?.target !== this.details) {
            this.bindTransition();
            return;
        }
        this.details.classList.remove(
            'p80-accordion__item--opening',
            'p80-accordion__item--closing'
        );
        this.details.open = !this.open;
        this.details.style.height = null;
        this.toggleFocusable();
    }

    toggleFocusable() {
        const focusable = getFocusableElements(this.content);
        const summaryIndex =
            this.details.open &&
            this.mobileOnly &&
            this.currentMediaQuery.type !== p80.mediaQueryService.mediaTypes.small
                ? -1
                : this.details.open
                  ? 0
                  : -1;
        const index = !this.details.open ? -1 : 0;
        this.summary.setAttribute('tabindex', summaryIndex);
        focusable.forEach((element) => {
            element.setAttribute('tabindex', index);
        });
    }

    yieldToMain() {
        return new Promise((resolve) => {
            setTimeout(resolve, 0);
        });
    }

    async yieldAndOpen() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.open = false;
        this.details.open = true;
        this.bindTransition();
        await this.yieldToMain();
        this.details.classList.add('p80-accordion__item--opening');
        this.details.style.height = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    }

    async yieldAndClose() {
        this.open = true;
        this.details.style.height = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        this.bindTransition();
        await this.yieldToMain();
        this.details.classList.add('p80-accordion__item--closing');
        this.details.style.height = `${this.summary.offsetHeight}px`;
    }

    bindTransition() {
        this.details.addEventListener('transitionend', this.onTransitionEndHandler, { once: true });
    }

    unbind() {
        this.summary.removeEventListener('click', this.onClickHandler);
        this.summary.addEventListener('keydown', this.onKeyDownHandler);
    }
}

/***
 *
 * Accordion
 *
 * Creates on-page animated accordions utilizing accessible details/summary markup
 * Utilizes @AccordionItem
 *
 * @param {boolean} (optional) data-mobile-only
 *
 * This flag will disable the accordion functionality on desktop
 * Allowing items to behave as if they were not in an accordion at desktop resolutions
 * When true the accordions will be expanded by default on desktop - and only become toggleable on mobile
 * Think menus in the footer of the website: we display them on desktop - however on mobile they collapse into an accordion
 *
 */

class Accordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const accordions = Array.from(this.querySelectorAll('details'));
        this.mobileOnly = this.getAttribute('data-mobile-only') === 'true' ? true : false;
        this.accordions = accordions.map(
            (accordion) => new AccordionItem(accordion, { mobileOnly: this.mobileOnly })
        );

        this.currentMediaQuery = p80.mediaQueryService.currentMediaQuery;
        this.onMediaQueryChange();
        this.mediaQueryChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.mediaQueryChange, (event) => {
            if (!event || !event.currentMedia) return;
            this.currentMediaQuery = event.currentMedia;
            this.onMediaQueryChange();
        });
    }

    disconnectedCallback() {
        this.accordions.forEach((accordion) => {
            accordion.unbind();
        });
        if (this.mediaQueryChangeUnsubscriber) {
            this.mediaQueryChangeUnsubscriber();
        }
    }

    onMediaQueryChange() {
        this.accordions.forEach((accordion) => {
            accordion.currentMediaQuery = this.currentMediaQuery;
            if (this.mobileOnly) {
                const open =
                    this.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.small
                        ? false
                        : true;
                accordion.details.open = open;
            }
            accordion.toggleFocusable();
        });
    }
}

customElements.define('accordion-component', Accordion);

/***
 *
 * Glide Component
 *
 * A slider implementation that can be utilized with only markup knowledge
 *
 * @param {boolean} (optional) data-disable
 * Will stop the slider logic from loading. Useful in scenarios where we only have a single slide e.g. a banner image.
 *
 * @param {number} (optional) data-animation-duration
 * The animation duration when changing slides
 *
 * @param {boolean} (optional) data-auto-rotate
 * Enables/Disables slider auto-rotation
 *
 * @param {number} (optional) data-auto-rotate-duration
 * The delay between changing slides when data-auto-rotate is TRUE
 *
 * @param {number} (optional) data-desktop-columns
 * The number of slides displayed on desktop. This can be a decimal/fraction.
 *
 * @param {number} (optional) data-tablet-columns
 * The number of slides displayed on tablet. This can be a decimal/fraction.
 *
 * @param {number} (optional) data-mobile-columns
 * The number of slides displayed on mobile. This can be a decimal/fraction.
 *
 * @param {number/string} (optional) data-focus-at
 * Where to focus the slider during/after animations. Almost always 0, however 'center' is an option
 *
 * @param {number} (optional) data-start-at
 * Which slide the slider starts at on initialization.
 *
 * @param {number} (optional) data-column-gap
 * How much space is injected between each slide (i.e. the grid)
 *
 * @param {string} (optional) data-pagination-style
 * what type of pagination do we render? (bullets, numbers, arrows)
 *
 * @param {boolean} (optional) data-pagination-desktop
 * Do we render pagination on desktop?
 *
 * @param {boolean} (optional) data-pagination-tablet
 * Do we render pagination on tablet?
 *
 * @param {boolean} (optional) data-pagination-mobile
 * Do we render pagination on mobile?
 *
 * @param {boolean} (optional) data-auto-resize
 * This is only intended for use with the markup in p80-slideshow.
 * This will automatically scale the slideshow height based on the current slide content.
 *
 * @param {boolean} (optional) data-wait-for-render
 * This will stop glide from initializing until it's manually called.
 * Sliders require their containing markup layout to be finalized before they can generate.
 * This parameter becomes useful when content is dynamically generated or injected on page.
 *
 */

class GlideComponent extends HTMLElement {
    static observedAttributes = [
        'data-disable',
        'data-animation-duration',
        'data-auto-rotate',
        'data-auto-rotate-duration',
        'data-desktop-columns',
        'data-tablet-columns',
        'data-mobile-columns',
        'data-focus-at',
        'data-start-at',
        'data-column-gap',
        'data-wait-for-render',
        'data-pagination-style',
        'data-pagination-desktop',
        'data-pagination-tablet',
        'data-pagination-mobile'
    ];

    constructor() {
        super();
        this.connected = false;
        this.bound = false;
    }

    connectedCallback() {
        this.connected = true;
        this.currentMediaQuery = p80.mediaQueryService.currentMediaQuery;
        this.onResizeHandler = this.setHeight.bind(this);

        this.setConfiguration();
        this.setSubscriptions();

        if (this.disable) {
            this.classList.add('glide-component--disabled');
            this.classList.add('glide-component--loaded');
            this.hideLoader();
            if (this.autoResize) {
                document.addEventListener('DOMContentLoaded', this.onResizeHandler);
                this.resizeObserver = new ResizeObserver((entries) => {
                    this.onResizeHandler(entries);
                });
                this.resizeObserver.observe(this.slider);
            }
            return;
        }

        // Manual keyboard navigation support - glide's default is "broken"
        this.onKeyUp = this.onKeyUp.bind(this);
        this.addEventListener('keyup', this.onKeyUp);

        const renderTasks = [
            this.initializeGlide.bind(this),
            this.generateBulletPagination.bind(this),
            this.generateArrowPagination.bind(this),
            this.generateNumberPagination.bind(this),
            this.setGlideBindings.bind(this),
            this.mountGlide.bind(this)
        ];

        if (typeof Glide !== 'undefined') {
            this.yieldTasks(renderTasks);
        } else {
            this.onLoadHandler = this.yieldTasks.bind(this, renderTasks);
            document.addEventListener('DOMContentLoaded', this.onLoadHandler);
        }
    }

    disconnectedCallback() {
        this.connected = false;
        if (this.glideUpdateUnsubscriber) {
            this.glideUpdateUnsubscriber();
        }
        if (this.mediaQueryChangeUnsubscriber) {
            this.mediaQueryChangeUnsubscriber();
        }
        this.resizeObserver?.disconnect();
        this.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('DOMContentLoaded', this.onLoadHandler);
        if (this.glide) {
            try {
                this.glide.destroy();
            } catch (e) {
                console.info(e);
            }
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.connected) return;
        const tasks = [
            this.setConfiguration.bind(this),
            this.initializeGlide.bind(this),
            this.generateBulletPagination.bind(this),
            this.generateArrowPagination.bind(this),
            this.generateNumberPagination.bind(this),
            this.setGlideBindings.bind(this),
            this.mountGlide.bind(this)
        ];
        if (oldValue !== newValue) this.yieldTasks(tasks);
    }

    yieldToMain() {
        return new Promise((resolve) => {
            setTimeout(resolve, 0);
        });
    }

    async yieldTasks(tasks) {
        while (tasks.length > 0) {
            const task = tasks.shift();
            task();
            await this.yieldToMain();
        }
    }

    setSubscriptions() {
        this.glideUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.glideUpdate, (event) => {
            if (event.id !== this.id) return;
            this.onUpdateBroadcast(event);
        });

        this.mediaQueryChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.mediaQueryChange, (event) => {
            this.onMediaQueryChange(event);
        });
    }

    setConfiguration() {
        this.showLoader();
        this.classList.remove('glide-component--loaded');
        if (this.glide) {
            try {
                this.glide.destroy();
            } catch (e) {
                console.info(e);
            }
        }

        // Internal configs
        this.disable = this.getAttribute('data-disable') === 'true' ? true : false;
        this.slider = this.querySelector('.glide');
        this.slides = this.querySelectorAll('.glide__slides > li');
        this.glide = null;
        this.loader = this.querySelector('.slideshow__loader');
        this.id = this.getAttribute('data-id') ? this.getAttribute('data-id') : null;

        // Slider Configs
        const animationDuration = this.getAttribute('data-duration');
        this.animationDuration = !Number.isNaN(parseFloat(animationDuration, 10))
            ? parseFloat(animationDuration, 10)
            : 400;

        this.autoRotate = this.getAttribute('data-auto-rotate') === 'true' ? true : false;
        const autoRotateDuration = this.getAttribute('data-auto-rotate-duration');
        this.autoRotateDuration = !Number.isNaN(parseFloat(autoRotateDuration, 10))
            ? parseFloat(autoRotateDuration, 10)
            : 0;

        const desktopColumns = this.getAttribute('data-desktop-columns');
        // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
        this.desktopColumns = !Number.isNaN(parseFloat(desktopColumns, 10))
            ? parseFloat(desktopColumns, 10)
            : 1;

        // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
        const tabletColumns = this.getAttribute('data-tablet-columns');
        this.tabletColumns = !Number.isNaN(parseFloat(tabletColumns, 10))
            ? parseFloat(tabletColumns, 10)
            : 1;

        const mobileColumns = this.getAttribute('data-mobile-columns');
        // This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
        this.mobileColumns = !Number.isNaN(parseFloat(mobileColumns, 10))
            ? parseFloat(mobileColumns, 10)
            : 1;

        const focusAt = this.getAttribute('data-focus-at');
        // focusAt can be an integer or string per glide docs - e.g. 'center'
        this.focusAt =
            focusAt === 'center'
                ? focusAt
                : !Number.isNaN(parseFloat(focusAt, 10))
                  ? parseFloat(focusAt, 10)
                  : 0;

        const startAt = this.getAttribute('data-start-at');
        this.startAt = !Number.isNaN(parseInt(startAt, 10)) ? parseInt(startAt, 10) : 0;

        const columnGap = this.getAttribute('data-column-gap');
        this.columnGap = !Number.isNaN(parseInt(columnGap, 10)) ? parseInt(columnGap, 10) : 24;
        this.columnGapMobile = (this.columnGap * 68) / 100;

        // This is only intended for use via p80-slideshow
        this.autoResize = this.getAttribute('data-auto-resize') === 'true' ? true : false;

        this.waitForRender = this.getAttribute('data-wait-for-render') === 'true' ? true : false;

        this.desktopPagination =
            this.getAttribute('data-pagination-desktop') === 'true' ? true : false;
        this.tabletPagination =
            this.getAttribute('data-pagination-tablet') === 'true' ? true : false;
        this.mobilePagination =
            this.getAttribute('data-pagination-mobile') === 'true' ? true : false;

        this.paginationStyles = {
            bullets: 'bullets',
            numbers: 'numbers',
            arrows: 'arrows',
            arrowsBullets: 'arrowsBullets'
        };
        const paginationStyle = this.getAttribute('data-pagination-style');
        this.paginationStyle = this.paginationStyles[paginationStyle]
            ? this.paginationStyles[paginationStyle]
            : null;
    }

    onMediaQueryChange(event) {
        if (!event || !event.currentMedia) return;
        this.currentMediaQuery = event.currentMedia;
    }

    // This is only intended for use via p80-slideshow
    setHeight() {
        const activeSlide = this.glide ? this.slides[this.glide.index] : this.slides[0];
        const activeMedia = activeSlide?.querySelectorAll('.slideshow__image');
        const activeText = activeSlide?.querySelector('.slideshow__content');
        const activeTextHeight = activeText ? activeText.scrollHeight : 0;
        const activeBreakpointMedia =
            this.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.small && activeMedia[1]
                ? activeMedia[1]
                : activeMedia[0]
                  ? activeMedia[0]
                  : null;
        const activeImageHeight = activeBreakpointMedia?.offsetHeight;

        if (!activeTextHeight || !activeImageHeight) return;

        const finalHeight =
            activeTextHeight > activeImageHeight ? activeTextHeight : activeImageHeight;

        this.style.setProperty('--height', `${finalHeight}px`);
    }

    onKeyUp(event) {
        if (!this.glide) return;
        const code = event.code ? event.code : event.keyCode;
        const right = [39, 'ArrowRight'];
        const left = [37, 'ArrowLeft'];

        const direction = right.includes(code) ? '>' : left.includes(code) ? '<' : null;
        if (!direction) return;

        this.glide.go(direction);
    }

    generateBulletPagination() {
        const bullets = this.querySelector('.glide__bullets');
        bullets?.remove();
        this.bullets = null;

        if (
            (this.paginationStyle !== this.paginationStyles.arrows &&
                this.paginationStyle !== this.paginationStyles.bullets &&
                this.paginationStyle !== this.paginationStyles.arrowsBullets) ||
            (this.paginationStyle === this.paginationStyles.arrows && !this.mobilePagination)
        ) {
            return;
        }

        const container = document.createElement('div');
        container.classList.add('glide__bullets');
        container.setAttribute('data-glide-el', 'controls[nav]');
        if (!this.mobilePagination || this.paginationStyle === this.paginationStyles.arrows)
            container.classList.add('large-up-hide');
        if (!this.tabletPagination && this.paginationStyle !== this.paginationStyles.arrows)
            container.classList.add('medium-hide');
        if (!this.desktopPagination && this.paginationStyle !== this.paginationStyles.arrows)
            container.classList.add('small-hide');

        const desktopBullets = this.slides.length - (Math.floor(this.desktopColumns) - 1);
        const tabletBullets = this.slides.length - (Math.floor(this.tabletColumns) - 1);
        const mobileBullets = this.slides.length - (Math.floor(this.mobileColumns) - 1);
        this.slides.forEach((slide, index) => {
            const count = index + 1;
            const bullet = document.createElement('button');
            if (count > desktopBullets) bullet.classList.add('large-up-hide');
            if (count > tabletBullets) bullet.classList.add('medium-hide');
            if (count > mobileBullets) bullet.classList.add('small-hide');
            bullet.classList.add('glide__bullet');
            bullet.setAttribute('data-glide-dir', `=${index}`);
            bullet.setAttribute('title', `Slide ${count}`);
            container.appendChild(bullet);
        });

        this.querySelector('.glide').appendChild(container);
        this.bullets = this.querySelector('.glide__bullets');
    }

    generateNumberPagination() {
        const pagination = this.querySelector('.glide__pagination');
        const oldPreviousButton = pagination?.querySelector(`[aria-label="Previous"]`);
        const oldNextButton = pagination?.querySelector(`[aria-label="Next"]`);
        oldPreviousButton?.removeEventListener('click', this.previousSlideHandler);
        oldNextButton?.removeEventListener('click', this.nextSlideHandler);
        pagination?.remove();
        this.pagination = null;

        if (this.paginationStyle !== this.paginationStyles.numbers) return;

        const container = document.createElement('div');
        container.classList.add('glide__pagination');
        if (!this.desktopPagination) container.classList.add('large-up-hide');
        if (!this.tabletPagination) container.classList.add('medium-hide');
        if (!this.mobilePagination) container.classList.add('small-hide');

        const desktopPages = this.slides.length - (Math.floor(this.desktopColumns) - 1);
        const tabletPages = this.slides.length - (Math.floor(this.tabletColumns) - 1);
        const mobilePages = this.slides.length - (Math.floor(this.mobileColumns) - 1);

        const prevButton = document.createElement('button');
        prevButton.setAttribute('type', 'button');
        prevButton.setAttribute('aria-label', 'Previous');
        prevButton.innerHTML = window.icons.caret;
        prevButton.addEventListener('click', this.previousSlideHandler);
        container.appendChild(prevButton);

        const count = document.createElement('p');
        count.setAttribute('data-count', true);
        const defaultCount = document.createElement('span');
        defaultCount.textContent = this.startAt + 1;
        container.appendChild(defaultCount);

        const divider = document.createElement('span');
        divider.textContent = '/';
        container.appendChild(divider);

        const desktop = document.createElement('span');
        desktop.classList.add('small-hide', 'medium-hide');
        desktop.textContent = `${desktopPages}`;
        container.appendChild(desktop);

        const tablet = document.createElement('span');
        tablet.classList.add('large-up-hide', 'small-hide');
        tablet.textContent = `${tabletPages}`;
        container.appendChild(tablet);

        const mobile = document.createElement('span');
        mobile.classList.add('large-up-hide', 'medium-hide');
        mobile.textContent = `${mobilePages}`;
        container.appendChild(mobile);

        const nextButton = document.createElement('button');
        nextButton.setAttribute('type', 'button');
        nextButton.setAttribute('aria-label', 'Next');
        nextButton.innerHTML = window.icons.caret;
        nextButton.addEventListener('click', this.nextSlideHandler);
        container.appendChild(nextButton);

        this.querySelector('.glide').appendChild(container);
        this.pagination = this.querySelector('.glide__pagination');
    }

    generateArrowPagination() {
        const arrows = this.querySelector('.glide__controls');
        arrows?.remove();
        this.arrows = null;

        if (
            this.paginationStyle !== this.paginationStyles.arrows &&
            this.paginationStyle !== this.paginationStyles.arrowsBullets
        )
            return;

        const container = document.createElement('div');
        container.classList.add('glide__controls');
        container.setAttribute('data-glide-el', 'controls');
        if (!this.desktopPagination) container.classList.add('large-up-hide');
        container.classList.add('medium-hide');
        // We will never display these on mobile due to space constraints
        container.classList.add('small-hide');

        const previous = document.createElement('button');
        previous.setAttribute('type', 'button');
        previous.classList.add('glide__previous');
        previous.setAttribute('data-glide-dir', '<');
        previous.setAttribute('aria-label', window.accessibilityStrings.previousSlide);
        previous.innerHTML = window.icons.chevron;
        container.appendChild(previous);

        const next = document.createElement('button');
        next.setAttribute('type', 'button');
        next.classList.add('glide__next');
        next.setAttribute('data-glide-dir', '>');
        next.setAttribute('aria-label', window.accessibilityStrings.nextSlide);
        next.innerHTML = window.icons.chevron;
        container.appendChild(next);
        this.querySelector('.glide').appendChild(container);
        this.arrows = this.querySelector('.glide__controls');
    }

    initializeGlide() {
        const component = this;
        this.glide = new Glide(component.slider, {
            type: 'slider',
            bound: true,
            animationDuration: component.animationDuration,
            focusAt: component.focusAt,
            startAt: component.startAt,
            perView: component.desktopColumns,
            gap: component.columnGap,
            autoplay: component.autoRotate ? component.autoRotateDuration : false,
            // Glide binds this to a global listener - using default keyboard navigation controls *every* slider on the page, regardless of focus
            // We create a manual scoped binding instead
            keyboard: false,
            breakpoints: {
                750: {
                    perView: component.mobileColumns,
                    gap: component.columnGapMobile
                },
                990: {
                    perView: component.tabletColumns
                },
                // These resolve an unfixed Glide bug
                5000: {
                    perView: component.desktopColumns
                },
                9999: {
                    perview: component.desktopColumns
                }
            }
        });
        this.nextSlideHandler = () => this.glide.go('>');
        this.previousSlideHandler = () => this.glide.go('<');
    }

    setGlideBindings() {
        this.glide.on('mount.after', () => {
            this.glide.isMounted = true;
        });

        this.glide.on('move.after', () => {
            const currentSlideIndicator = this.pagination?.querySelector('span');
            if (currentSlideIndicator) currentSlideIndicator.textContent = this.glide.index + 1;
            if (this.autoResize) {
                this.onResizeHandler();
            }
        });

        if (this.autoResize) {
            this.glide.on('resize', () => {
                this.onResizeHandler();
            });
        }

        this.glide.on('build.after', () => {
            if (this.autoResize) {
                this.onResizeHandler();
            }
            this.classList.add('glide-component--loaded');
            this.hideLoader();
            setTimeout(() => {
                this.showPagination();
            }, 500);
        });
    }

    mountGlide() {
        this.glide.mount();
    }

    showPagination() {
        this.bullets?.classList.add('glide__bullets--visible');
        this.pagination?.classList.add('glide__pagination--visible');
        this.arrows?.classList.add('glide__controls--visible');
    }

    hidePagination() {
        this.bullets?.classList.remove('glide__bullets--visible');
        this.pagination?.classList.remove('glide__pagination--visible');
        this.arrows?.classList.remove('glide__controls--visible');
    }

    showLoader() {
        this.loader?.classList.add('slideshow__loader--visible');
    }

    hideLoader() {
        this.loader?.classList.remove('slideshow__loader--visible');
    }

    onUpdateBroadcast(event) {
        if (this.glide && this.glide.isMounted) return;
        if (this.waitForRender) {
            this.waitForRender = false;
            if (!this.slides || !this.slides.length) {
                this.slides = this.querySelectorAll('.glide__slides > li');
            }
            const tasks = [
                this.initializeGlide.bind(this),
                this.generateBulletPagination.bind(this),
                this.generateArrowPagination.bind(this),
                this.generateNumberPagination.bind(this),
                this.setGlideBindings.bind(this),
                this.mountGlide.bind(this)
            ];
            this.yieldTasks(tasks);
        }
    }
}

customElements.define('glide-component', GlideComponent);

class StickyBarService {
    constructor() {
        this.loaded = false;
        this.alignments = {
            top: 'top',
            bottom: 'bottom'
        };
        this.elements = [];
        this.displayedElements = {
            top: [],
            bottom: []
        };
        this.footer = document.querySelector('footer');
        this.watchEndElement = null;
        const tasks = [
            this.getHeaderHeight.bind(this),
            this.setRootMargins.bind(this),
            this.setHandlers.bind(this)
        ];

        this.yieldTasks(tasks);
    }

    yieldToMain() {
        return new Promise((resolve) => {
            setTimeout(resolve, 0);
        });
    }

    async yieldTasks(tasks) {
        while (tasks.length > 0) {
            const task = tasks.shift();
            task();
            await this.yieldToMain();
        }
    }

    onLoad() {
        this.loaded = true;
        this.setElementObservers();
    }

    onResize(entries) {
        const previousHeaderHeight = this.headerHeight;
        this.getHeaderHeight();
        this.setRootMargins();
        const alignmentsToUpdate = [];
        if (previousHeaderHeight !== this.headerHeight) {
            alignmentsToUpdate.push(this.alignments.top);
        }
        this.setElementOffsets(alignmentsToUpdate);
        this.setElementObservers();
    }

    onIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.target.tagName.toLowerCase() === 'footer') {
                if (entry.isIntersecting) {
                    this.hideElements([this.alignments.bottom]);
                } else {
                    this.showElements([this.alignments.bottom]);
                }
                return;
            } else if (entry.target.classList.contains(this.watchEndElement.replace('.', ''))) {
                if (entry.isIntersecting && window.innerWidth > 990) {
                    this.hideElements([this.alignments.top]);
                } else {
                    this.showElements([this.alignments.top]);
                }
                return;
            }
            const stickyBar = this.elements.find((element) => {
                return element.watchElement === entry.target;
            });
            const isVisible = entry.isIntersecting
                ? true
                : (!entry.isIntersecting && window.scrollY >= entry.boundingClientRect.top) ||
                    entry.boundingClientRect.bottom < 0
                  ? false
                  : true;
            if (isVisible && stickyBar.isVisible) {
                this.disableElement(stickyBar);
            } else if (!isVisible && !stickyBar.isVisible) {
                this.enableElement(stickyBar);
            }
        });
    }

    setHandlers() {
        this.unsubscribeHandler = this.unsubscribe.bind(this);

        this.resizeHandler = this.onResize.bind(this);
        this.resizeObserver = new ResizeObserver((entries) => this.resizeHandler(entries));

        this.intersectionHandler = this.onIntersect.bind(this);

        // Browser auto-scroll on window load bypasses interesection observers
        // We need to wait to actually start observing until after the page load event has fired
        if (document.readyState == 'complete') {
            this.onLoad();
        } else {
            window.addEventListener('load', () => this.onLoad());
        }
    }

    setRootMargins() {
        this.rootMargin = `-${this.headerHeight}px 0px 0px 0px`;
    }

    enableElement(element) {
        const matchingElement = this.elements.find((el) => {
            return el === element;
        });
        if (!matchingElement) return;
        this.displayedElements[matchingElement.alignment]?.push(matchingElement);
        this.setElementOffsets([matchingElement.alignment]);
        matchingElement.classList.add('sticky-bar--visible');
        matchingElement.isVisible = true;
    }

    disableElement(element) {
        const matchingElement = this.elements.find((el) => {
            return el === element;
        });
        if (!matchingElement) return;
        matchingElement.isVisible = false;
        matchingElement.classList.remove('sticky-bar--visible');
        this.displayedElements[matchingElement.alignment] = this.displayedElements[
            matchingElement.alignment
        ]?.filter((el) => {
            return el !== element;
        });
        this.setElementOffsets([matchingElement.alignment]);
    }

    hideElements(alignments) {
        if (!alignments?.length) return;
        alignments.forEach((alignment) => {
            this.displayedElements[alignment]?.forEach((element) => {
                element.classList.remove('sticky-bar--visible');
            });
        });
    }

    showElements(alignments) {
        if (!alignments?.length) return;
        alignments.forEach((alignment) => {
            this.displayedElements[alignment]?.forEach((element) => {
                element.classList.add('sticky-bar--visible');
            });
        });
    }

    setElementObservers() {
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = new IntersectionObserver(
            (entries) => this.intersectionHandler(entries),
            { threshold: [0], rootMargin: this.rootMargin }
        );
        this.intersectionObserver?.observe(this.footer);
        if (this.watchEndElement)
            this.intersectionObserver?.observe(document.querySelector(this.watchEndElement));
        this.elements.forEach((element) => {
            if (this.loaded) this.intersectionObserver.observe(element.watchElement);
        });
    }

    setElementOffsets(alignments) {
        if (!alignments?.length) return;
        alignments.forEach((alignment) => {
            let offset = 0;
            this.displayedElements[alignment]?.forEach((element, index) => {
                offset += element.offset;
                if (index === 0) {
                    offset += alignment === this.alignments.top ? this.headerHeight : 0;
                }
                element.style.setProperty('--offset', `${offset}px`);
                offset += element.offsetHeight;
            });
        });
    }

    getHeaderHeight() {
        this.header = document.querySelector('.header-wrapper');
        if (!this.header) return;
        this.headerType = this.header.tagName.toLowerCase();
        this.headerStickyType = this.header.getAttribute('data-sticky-type');
        this.headerHeight = this.headerStickyType === 'always' ? this.header.offsetHeight : 0;
    }

    subscribe(element) {
        if (!this.elements.length) {
            this.getHeaderHeight();
            this.resizeObserver.observe(this.header);
        }
        if (this.loaded) this.intersectionObserver?.observe(element.watchElement);
        this.elements.push(element);
        if (element.watchEndElement) this.watchEndElement = element.watchEndElement;
        return () => this.unsubscribeHandler(element);
    }

    unsubscribe(element) {
        if (!element) return;
        this.elements = this.elements.filter((el) => {
            return el !== element;
        });
        this.intersectionObserver?.unobserve(element.watchElement);
        if (!this.elements.length) this.resizeObserver.disconnect();
    }
}

p80.stickyBarService = new StickyBarService();

/***
 *
 * Sticky Bar
 *
 * Creates a sticky bar that will automatically watch an element on page and render itself when said element leaves the viewport
 *
 * @param {string} (optional) data-alignment
 * Where the sticky bar should slide in on page. 'top' or 'bottom'.
 *
 * @param {string} (required) data-watch-element
 * What element on page the sticky bar should watch. When the element leaves the viewport the sticky bar renders itself.
 * This parameter is provided in the form of a selector string e.g. data-watch-element="#element" or data-watch-element=".product-form__buttons [type='submit']"
 *
 * @param {string} (optional) data-offset
 * A pixel value which determines how far from the alignment point the sticky bar should render
 *
 * Automatic stacking for multiple bars and display/hiding based on scroll position is managed by `p80.stickyBarService`
 *
 *
 */

class StickyBar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.isVisible = false;

        this.watchEndElement = this.hasAttribute('data-watch-end-element')
            ? this.getAttribute('data-watch-end-element')
            : null;

        const tasks = [
            this.setConfiguration.bind(this),
            this.initializeWatchElement.bind(this),
            this.subscribe.bind(this)
        ];
        this.yieldTasks(tasks);
    }

    disconnectedCallback() {
        if (this.stickyBarUnsubscriber) this.stickyBarUnsubscriber();
    }

    yieldToMain() {
        return new Promise((resolve) => {
            setTimeout(resolve, 0);
        });
    }

    async yieldTasks(tasks) {
        while (tasks.length > 0) {
            const task = tasks.shift();
            task();
            await this.yieldToMain();
        }
    }

    setConfiguration() {
        this.alignment = this.hasAttribute('data-alignment')
            ? p80.stickyBarService.alignments[this.getAttribute('data-alignment')]
            : 'top';
        const offset = this.getAttribute('data-offset');
        const offsetSplit = offset?.match(/^([-.\d]+(?:\.\d+)?)(.*)$/);
        const offsetSize = offsetSplit?.length ? offsetSplit[1] : null;
        this.offset = !Number.isNaN(parseInt(offsetSize, 10)) ? parseInt(offsetSize, 10) : 0;
        this.offsetUnit = offsetSplit?.length ? offsetSplit[2] : 'px';
        this.classList.add(`sticky-bar--${this.alignment}`);
    }

    subscribe() {
        if (!this.watchElement) {
            console.error('Watch element not found.');
            return;
        }
        this.stickyBarUnsubscriber = p80.stickyBarService.subscribe(this);
    }

    initializeWatchElement() {
        this.watchElementId = this.hasAttribute('data-watch-element')
            ? this.getAttribute('data-watch-element')
            : null;
        if (!this.watchElementId) {
            console.error('No watch element selector set for the Sticky Bar');
            this.classList.add('hidden');
            return;
        }
        this.watchElement = document.querySelector(this.watchElementId);
        if (!this.watchElement) {
            console.error(`Unable to find the watch element with the ID ${this.watchElementId}`);
            this.classList.add('hidden');
            return;
        }
    }
}

customElements.define('sticky-bar', StickyBar);

/***
 *
 * Volume Discounts
 *
 * Displays price breaks for multiple purchase quantities of a product based on said products tags. Supports two methods of discount generation - fixed and percentage based.
 *
 * Tag format:
 * <token>:<qty>:<price>
 *
 * e.g.
 *
 * breakp:2:10 - 10% discount off a purchase of two items
 * breakp:4:20 - 20% discount off a purchase of four items
 * breakf:2:4000 - Purchase two of this item for 4000cents each ($40.00)
 * breakf:4:3800 - Purchase four of this item for 3800cents each ($38.00)
 *
 *
 * @param {number} (required) data-price - The price of the current product being viewed in cents
 *
 */

class VolumeDiscounts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.currency = Shopify && Shopify.currency ? Shopify.currency.active : null;
        if (!this.currency) {
            console.error('Currency code not specified.');
            return;
        }

        // Tags are output within a <script> element as a JSON payload rather than outputting them into data-attributes
        this.tags = this.querySelector('[type="application/json"]').textContent;
        if (!this.tags) return;

        this.tags = JSON.parse(this.tags);
        this.fixedTags = this.tags.filter((tag) => {
            return tag.includes('breakf');
        });
        this.percentageTags = this.tags.filter((tag) => {
            return tag.includes('breakp');
        });
        if (!this.fixedTags.length && !this.percentageTags.length) return;

        this.price = this.getAttribute('data-price');
        if (!this.price) return;
        this.price = parseInt(this.price, 10);

        this.chart = this.querySelector('ul');
        if (!this.chart) return;

        this.textLength = 0;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || !event.data.variant) return;
            this.price = event.data.variant.price;
            this.generate();
        });

        this.generate();
    }

    disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
        }
    }

    generate() {
        this.chart.textContent = '';
        this.percentageTags.forEach((tag) => {
            const tagData = this.formatTag(tag);
            const listEntry = this.generateHTML(tagData);
            this.chart.appendChild(listEntry);
        });
        this.fixedTags.forEach((tag) => {
            const tagData = this.formatTag(tag);
            const listEntry = this.generateHTML(tagData);
            if (listEntry) this.chart.appendChild(listEntry);
        });
        if (this.textLength > 22) this.classList.add('paragraph-small');
        this.classList.remove('hidden');
    }

    formatTag(tag) {
        if (!tag) return;
        const splitTag = tag.split(':');
        if (splitTag.length < 3) return;
        const tagData = {
            quantity: parseInt(splitTag[1], 10),
            discount: parseInt(splitTag[2], 10),
            type: splitTag[0] === 'breakp' ? 'percentage' : 'fixed'
        };
        return tagData;
    }

    generateHTML(tagData) {
        if (!tagData || Object.keys(tagData).length < 3) return;
        const entry = document.createElement('li');

        const label = document.createElement('span');
        label.textContent = `${window.variantStrings.volumeDiscountBuy} ${tagData.quantity}`;

        const priceWrapper = document.createElement('span');
        priceWrapper.classList.add('volume-discounts__pricing');

        const originalPrice = this.formatPrice(this.price);
        let discountPrice =
            tagData.type === 'percentage'
                ? this.price * (1 - tagData.discount / 100)
                : tagData.discount;
        // Check and make sure the discount price is less than the original price
        // For fixed discounts, an on-sale product may end up costing "more" and should be hidden
        if (this.price < discountPrice) return null;

        const discountBadge = document.createElement('span');
        discountBadge.classList.add('volume-discounts__badge');
        if (tagData.type === 'percentage') {
            discountBadge.textContent =
                window.variantStrings.volumeDiscountSave + ` ${tagData.discount}%`;
        } else {
            const percentage = Math.floor(
                ((this.price - tagData.discount) / this.price) * 100
            ).toFixed(0);
            discountBadge.textContent =
                window.variantStrings.volumeDiscountSave + ` ${percentage}%`;
        }
        priceWrapper.appendChild(discountBadge);

        const originalPriceWrapper = document.createElement('span');
        originalPriceWrapper.classList.add('volume-discounts__original');
        originalPriceWrapper.textContent = originalPrice;
        priceWrapper.appendChild(originalPriceWrapper);

        discountPrice = this.formatPrice(discountPrice);
        discountPrice = discountPrice + ` ${window.variantStrings.volumeDiscountEach}`;
        const discountPriceWrapper = document.createElement('span');
        discountPriceWrapper.classList.add('volume-discounts__sale');
        discountPriceWrapper.textContent = discountPrice;
        priceWrapper.appendChild(discountPriceWrapper);

        label.appendChild(priceWrapper);

        entry.appendChild(label);

        const textLength = originalPrice.length + discountPrice.length;
        if (textLength > this.textLength) this.textLength = textLength;

        return entry;
    }

    formatPrice(price) {
        if (!price) return;
        let formattedPrice = price / 100;

        const getLang = () => {
            if (navigator.languages != undefined) return navigator.languages[0];
            return navigator.language;
        };

        formattedPrice = formattedPrice.toLocaleString(getLang(), {
            style: 'currency',
            currency: this.currency
        });

        return formattedPrice;
    }
}

customElements.define('volume-discounts', VolumeDiscounts);

/***
 *
 * Countdown Timer
 *
 * Counts down to a specified date/time
 *
 * @param {date} (required) data-date - A date in the future YYYY/MM/DD
 *
 */

class CountDownTimer extends HTMLElement {
    static observedAttributes = ['data-date'];
    constructor() {
        super();
    }

    connectedCallback() {
        this.initialize();
    }

    attributeChangedCallback() {
        this.initialize();
    }

    disconnectedCallback() {
        clearInterval(this.countDownInterval);
    }

    initialize() {
        this.daysElement = this.querySelector('[data-target="days"]');
        this.hoursElement = this.querySelector('[data-target="hours"]');
        this.minutesElement = this.querySelector('[data-target="minutes"]');
        this.secondsElement = this.querySelector('[data-target="seconds"]');
        this.countDownDate = this.getAttribute('data-date');

        if (
            !this.daysElement ||
            !this.hoursElement ||
            !this.minutesElement ||
            !this.secondsElement ||
            !this.countDownDate
        )
            return;
        this.setValues();
        this.countDown();
    }

    setValues() {
        this.date = new Date(this.countDownDate).getTime();
        this.second = 1000;
        this.minute = this.second * 60;
        this.hour = this.minute * 60;
        this.day = this.hour * 24;
    }

    countDown() {
        this.countDownInterval = setInterval(() => {
            const now = new Date().getTime();
            const distance = this.date - now;
            this.daysElement.innerText = Math.floor(distance / this.day);
            this.hoursElement.innerText = Math.floor((distance % this.day) / this.hour);
            this.minutesElement.innerText = Math.floor((distance % this.hour) / this.minute);
            this.secondsElement.innerText = Math.floor((distance % this.minute) / this.second);

            if (distance > 0) return;
            clearInterval(this.countDownInterval);
        }, 1000);
    }
}

customElements.define('count-down-timer', CountDownTimer);

/***
 *
 * Anchor Menu
 *
 * Anchor menu that scroll to ID
 *
 * @param {string} (optional) data-accordion-wrapper
 * Accepts ID or class of the accordion element. e.g. '#Buying-guide-menu'
 *
 * @param {string} (required) data-menu-links
 * This is the class of the menu links. e.g. '.footer-menu__menu-item'
 *
 */

class AnchorMenu extends HTMLElement {
    constructor() {
        super();

        this.accordionWrapper = this.hasAttribute('data-accordion-wrapper')
            ? document.querySelector(this.getAttribute('data-accordion-wrapper'))
            : null;
        this.menuLinks = this.hasAttribute('data-menu-links')
            ? document.querySelectorAll(this.getAttribute('data-menu-links'))
            : null;

        if (!this.menuLinks) return;
        // Attach click event listener to each menu item
        this.menuLinks.forEach((menuItem) =>
            menuItem.addEventListener('click', this.setActiveLink.bind(this))
        );
    }

    setActiveLink(event) {
        // Remove active class from all items
        this.menuLinks.forEach((item) => item.classList.remove('active'));

        // Add active class to clicked item
        event.target.classList.add('active');

        if (!this.accordionWrapper) return;

        // Set the accordion title to selected menu item
        this.accordionWrapper.querySelector('.accordion__title').textContent =
            event.target.textContent;

        // For close buying guide accordion menu
        this.accordionWrapper.removeAttribute('open');
        this.accordionWrapper.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
}

customElements.define('anchor-menu', AnchorMenu);

document.addEventListener('DOMContentLoaded', function () {
    function initCollectionLinks() {
        // Use more specific selectors to improve performance
        const links = document.querySelectorAll(
            [
                '.mega-menu__content a[href*="/collections/"]',
                '.menu-drawer__navigation a[href*="/collections/"]',
                '#MainContent a[href*="/collections/"]'
            ].join(',')
        );

        links.forEach((link) => {
            link.addEventListener('click', handleCollectionClick);
        });
    }

    function handleCollectionClick(event) {
        // Get the current URL
        const storeLocation = localStorage.getItem('storeLocation');
        const storeAvailability = localStorage.getItem('storeAvailability');
        const storeWay = localStorage.getItem('storeWay');

        if (storeWay != 'pickup') return;

        event.preventDefault();
        if (!event.target.href) return;
        let updateHref = '';

        const encodedStoreLocation = encodeURIComponent(storeLocation);
        const pickupParams = `filter.v.m.p80.pickup_in_store=${encodedStoreLocation}`;
        const viewParams = `filter.v.m.p80.view_in_store=${encodedStoreLocation}`;
        const pwParams = storeAvailability == 'view' ? viewParams : pickupParams;
        const onlineParams = `filter.v.m.p80.shippable_quantity_boolean=1`;

        if (storeWay === 'pickup' && storeLocation) {
            updateHref = event.target.href.includes('filter.')
                ? `${event.target.href}&${pwParams}`
                : `${event.target.href}?${pwParams}`;
        } else if (storeWay === 'online') {
            updateHref = event.target.href.includes('filter.')
                ? `${event.target.href}&${onlineParams}`
                : `${event.target.href}?${onlineParams}`;
        }

        window.location.href = updateHref;
    }

    initCollectionLinks();
});
